import { useRef } from "react";
import { motion, useAnimationFrame, useMotionValue } from "framer-motion";
import { techStack } from "../data/portfolio";

export default function Marquee() {
  const baseX = useMotionValue(0);
  const ref = useRef(null);

  useAnimationFrame((_, delta) => {
    const moveBy = (delta / 1000) * 80; // px per second
    let newX = baseX.get() - moveBy;
    // Reset when we've scrolled one full copy width
    if (ref.current) {
      const fullWidth = ref.current.scrollWidth / 2;
      if (Math.abs(newX) >= fullWidth) newX = 0;
    }
    baseX.set(newX);
  });

  const items = [...techStack, ...techStack];

  return (
    <div
      style={{
        borderTop: "1px solid var(--border)",
        borderBottom: "1px solid var(--border)",
        background: "var(--surface)",
        overflow: "hidden",
        padding: "0.85rem 0",
      }}
    >
      <motion.div
        ref={ref}
        style={{ x: baseX, display: "flex", whiteSpace: "nowrap" }}
      >
        {items.map((item, i) => (
          <span
            key={i}
            style={{
              fontFamily: "var(--font-mono)",
              fontSize: "0.72rem",
              letterSpacing: "0.15em",
              color: "var(--muted)",
              textTransform: "uppercase",
              padding: "0 2.5rem",
              flexShrink: 0,
            }}
          >
            <span style={{ color: "var(--accent)", marginRight: "0.6rem" }}>▹</span>
            {item}
          </span>
        ))}
      </motion.div>
    </div>
  );
}
